<script>
import { mapState } from "vuex";
import PFGwSLogoComponent from "./PFGwSLogoComponent";
import PartnerLevelComponent from "@/components/common/PartnerLevelComponent";
import PFRiseWithSAPComponent from "@/components/common/PFRiseWithSAPComponent";
import PartnerLevelLogoComponent from "@/components/common/PartnerLevelLogoComponent";
import { useModalProvider } from "@/composables/useModalProvider";

export default {
  name: "PFRecognitionsComponent",
  components: {
    PartnerLevelComponent,
    PFGwSLogoComponent,
    PFRiseWithSAPComponent,
    PartnerLevelLogoComponent,
  },
  props: {
    growCountries: { type: Array, default: () => [] },
    localProfiles: { type: Array, default: () => [] },
  },
  setup() {
    const { openModal, isModalOpen } = useModalProvider();
    return {
      openPartnerLevelModal: openModal,
      isPartnerLevelModalOpen: isModalOpen,
    };
  },
  methods: {
    emitSWAEvent(name) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$eventBus.$emit("PFAACustomEvent", { eventName: "ClickModal", custom2: name });
    },
  },
  computed: {
    ...mapState("partnerProfile", {
      level: (state) => state.profileData.level,
      silverCountries: (state) => state.profileData.silverCountries,
      goldCountries: (state) => state.profileData.goldCountries,
      platinumCountries: (state) => state.profileData.uvarPlatinumCountries,
      solutionTransformed: (state) => state.solutionTransformed,
      isRiseValidated: (state) => state.profileData.isRiseValidated,
    }),
    isPartnerLeveleAvailable() {
      return this.level?.length > 0;
    },
    hasGrowCountries() {
      return this.growCountries?.length > 0;
    },
    showPlatinumLogo() {
      return this.level === "PLATINUM";
    },
    showGoldLogo() {
      return this.level !== "PLATINUM" && this.goldCountries?.length > 0;
    },
    showSilverLogo() {
      return this.level !== "PLATINUM" && this.silverCountries?.length > 0;
    },
    ERPObject() {
      return this.solutionTransformed?.find((s) => s.solutionL1Key === "PFERP");
    },
    hasCompetencyPrivateS4() {
      if (this.ERPObject && this.ERPObject.specializations) {
        const privateS4 = this.ERPObject?.specializations?.find((L2) => L2.solutionL2Key === "PFERPHCPE");
        if (privateS4 && privateS4.level && privateS4.level !== "Zero") {
          return true;
        }
      }
      return false;
    },
    showRecognitions() {
      return (
        this.showSilverLogo ||
        this.showGoldLogo ||
        this.showPlatinumLogo ||
        this.hasGrowCountries ||
        this.isRiseValidated
      );
    },
  },
  watch: {
    showRecognitions: {
      handler(newValue) {
        this.$emit("update-recognitions-visible", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col min-h-0">
    <div
      automation-id="partnerProfilePage-recognitionsHeader"
      class="recognitions-header"
      v-if="isPartnerLeveleAvailable || hasGrowCountries || isRiseValidated"
    >
      {{ $t("profile.recognitions.title") }}
    </div>
    <div automation-id="partnerProfilePage-partnerLevelContainer" class="flex flex-row flex-wrap gap-6 mt-4">
      <PFRiseWithSAPComponent v-if="isRiseValidated" />
      <PFGwSLogoComponent
        v-if="hasGrowCountries"
        :growCountries="growCountries"
        :localProfiles="localProfiles"
        :analyticsOrigin="'At_A_Glance'"
      />

      <div
        v-if="isPartnerLeveleAvailable"
        automation-id="partnerProfilePage-partnerLevel"
        class="w-[78px] h-[46px] cursor-pointer transition-all duration-200 ease-in-out hover:scale-[1.065]"
        @click="
          openPartnerLevelModal();
          emitSWAEvent('At_A_Glance_Medallion');
        "
      >
        <PartnerLevelLogoComponent :partnerLevelType="level" height="46px" width="78px" />
      </div>
      <PartnerLevelComponent v-if="isPartnerLevelModalOpen" />
    </div>
  </div>
</template>
